// extracted by mini-css-extract-plugin
export default {"console":"BookingReminder_console__Ti+h1","container":"BookingReminder_container__oZAg-"};